import { getRelatedPublicationListing } from '../../templates/Publication/lib/get-related-publication-listing'

import { RelatedPublications } from './Publication.props'
import { DataDefinition } from 'json-react-layouts-data-loader'
import { ComponentServices } from '@news-mono/web-common'
import {
    isFeatureEnabled,
    toFeatureState,
} from '@etrigan/feature-toggles-client'

export interface PublicationDataContent {
    publicationId: string
}

export interface PublicationDataResult {
    relatedPublications?: RelatedPublications
}

export type ArticlePublicationDataDefinition = DataDefinition<
    PublicationDataContent,
    PublicationDataResult,
    ComponentServices
>

export const ArticlePublicationDataDefinitionLoader: ArticlePublicationDataDefinition = {
    loadData: async (props, services) => {
        let relatedPublications: RelatedPublications | undefined

        const appState = services.store.getState()
        if (
            isFeatureEnabled(
                toFeatureState(appState.toggles),
                'related-content',
            )
        ) {
            relatedPublications = await getRelatedPublicationListing(
                services,
                props.publicationId,
            )
        }

        return { relatedPublications }
    },
}
